import { useContext } from 'react';
import {
    Button,
    Card,
    CardBody,
    CardLink,
    CardText,
    CardTitle,
} from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { CampaignContext } from '~/context/campaign';
import { getDashColor } from '../icons';

export const ImageTipsCard = () => {
    const history = useHistory();
    const title = 'Tips for your Campaign Image';

    return (
        <Card
            className='mt-5'
            style={{
                background: getDashColor('supporters'),
                fontSize: '14px',
            }}
        >
            <CardBody>
                <CardTitle className='eyebrow' style={{ fontSize: '14px' }}>
                    {title}
                </CardTitle>
                <ul>
                    <li>Images should be in PNG or JPG format.</li>
                    <li>Images should be at least 600 pixels wide.</li>
                    <li>
                        Images should be clear and properly represent the
                        campaign initiative.
                    </li>
                    <li>
                        Images should not include any copyrighted information.
                    </li>
                </ul>
                <CardLink
                    onClick={() => history.push('/helpful-tools')}
                    style={{ cursor: 'pointer' }}
                >
                    Successful Campaign Tips
                </CardLink>
            </CardBody>
        </Card>
    );
};

export const StoryTipsCard = () => {
    const [{ campaign }, campaignDispatch] = useContext(CampaignContext);
    const history = useHistory();
    const title = 'Tips for your Campaign Story';
    return (
        <Card
            style={{
                background: getDashColor('supporters'),
                fontSize: '14px',
            }}
        >
            <CardBody>
                <CardTitle className='eyebrow' style={{ fontSize: '14px' }}>
                    {title}
                </CardTitle>
                <CardText>
                    If you are looking for some inspiration when it comes to
                    writing your Campaign Story please check out some examples
                    of successful campaigns:
                </CardText>
                <CardLink
                    onClick={() => history.push('/helpful-tools')}
                    style={{ cursor: 'pointer' }}
                >
                    Successful Campaign Tips
                </CardLink>
                <br />
                <CardLink
                    href={`${
                        campaign?.campaignDetail?.campaign_type?.code ===
                        'transplant'
                            ? 'https://s3.amazonaws.com/helphopelive/media/forms_n_flyers/Your_Campaign_Story_-_Transplant.pdf'
                            : 'https://s3.amazonaws.com/helphopelive/media/forms_n_flyers/Your_Campaign_Story_-_Injury_or_Illness.pdf'
                    }`}
                    target='_blank'
                >
                    How to write your story
                </CardLink>
            </CardBody>
        </Card>
    );
};

export const NoCampaignCard = () => {
    const wp_home = import.meta.env.VITE_WP_URL;
    const history = useHistory();
    const title = "Don't have a campaign?";
    
    const handleGetStartedClick = () => {
        const isProduction = import.meta.env.PROD;
        const useLegacyPassword = import.meta.env.VITE_USE_LEGACY_PASSWORD === 'true';
        
        if (isProduction && useLegacyPassword) {
            // Redirect to external Help Hope Live website when in production with legacy password enabled
            window.location.href = 'https://helphopelive.org/get-started/';
            return;
        }
        
        history.push('/get-started/account-setup');
    };
    
    return (
        <Card
            className='h-100 text-center'
            style={{
                // width: '250px',
                background: 'rgba(1, 174, 180, 0.25)',
                // fontSize: '14px',
            }}
        >
            <CardBody className='px-5 d-flex flex-column justify-content-center align-items-center'>
                <h3 className='mb-5'>{title}</h3>
                <CardText className='mb-5'>
                    Unlock a powerful way to raise money for medical expenses
                    and related costs with our expert guidance and unique
                    nonprofit benefits.
                </CardText>
                <Button
                    color='outline-dark'
                    aria-label='Get Started'
                    onClick={handleGetStartedClick}
                >
                    Get Started
                </Button>
            </CardBody>
        </Card>
    );
};
